import DashboardLayout from '../layouts/DashboardLayout'

export const campaignManagement = {
  path: '',
  component: DashboardLayout,
  name: 'Campaign',
  redirect: '/campaign',
  children: [
    {
      path: '/campaign',
      name: 'Campaign',
      component: () => import (/* webpackChunkName: "campaign" */'../pages/campaign-management/index.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lý chiến dịch',
        }],
        title: 'OMS Campaign List',
      },
    },
    {
      path: '/campaign/create',
      name: 'CreateCampaign',
      component: () => import (/* webpackChunkName: "campaign" */'../pages/campaign-management/detail.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }],
        title: 'OMS New Campaign',
      },
    },
    {
      path: '/campaign/detail/:id',
      name: 'DetailCampaign',
      component: () => import (/* webpackChunkName: "campaign" */'../pages/campaign-management/detail.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }]
      },
    },
    {
      path: '/campaign/update/:id',
      name: 'UpdateCampaign',
      component: () => import (/* webpackChunkName: "campaign" */'../pages/campaign-management/detail.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }]
      },
    },
  ],
}
